export default {
    aboutUs: 'Acerca de',
    support: 'Soporte',
    contactUs: 'Contáctanos',
};
